import React from 'react';

import { Icon } from '@rbilabs/universal-components';
import { StyleSheet, useWindowDimensions } from 'react-native';

import { Box, Typography } from 'components/ui';
import { primitive, spacing } from 'styles/constants';
import { breakpoints } from 'styles/constants/breakpoints';

interface StoreCardMessagesProps {
  errorMessage?: string;
  accessInstructions?: string;
}

interface StoreCardErrorMessageProps {
  errorMessage: string;
}

const StoreCardErrorMessage: React.FC<StoreCardErrorMessageProps> = ({ errorMessage }) => {
  const { width } = useWindowDimensions();

  const errorMessageWidthStyle =
    width >= breakpoints.lg ? styles.errorMessageContainerLg : styles.errorMessageContainerBase;
  const errorIconWrapperStyle =
    width >= breakpoints.md ? styles.errorIconWrapperMd : styles.errorIconWrapperBase;

  return (
    <Box focusable style={[styles.errorMessageContainer, errorMessageWidthStyle]}>
      <Box style={[styles.errorIconWrapper, errorIconWrapperStyle]}>
        <Icon size="xs" variant="info" />
      </Box>
      <Typography variant="copyTwo">{errorMessage}</Typography>
    </Box>
  );
};

export const StoreCardMessages: React.FC<StoreCardMessagesProps> = ({
  errorMessage,
  accessInstructions,
}) => {
  if (!errorMessage && !accessInstructions) {
    return null;
  }

  return (
    <Box>
      {accessInstructions && (
        <Typography variant="copyTwo" color={primitive.$blackOpacity50}>
          {accessInstructions}
        </Typography>
      )}
      {errorMessage && <StoreCardErrorMessage errorMessage={errorMessage} />}
    </Box>
  );
};

const styles = StyleSheet.create({
  errorIconWrapper: {
    marginRight: spacing.$1,
  },
  errorIconWrapperBase: {
    marginTop: spacing.$0,
  },
  errorIconWrapperMd: {
    marginTop: spacing.$0_5,
  },
  errorMessageContainer: {
    backgroundColor: primitive.$warningLight,
    borderRadius: 4,
    flexDirection: 'row',
    marginTop: spacing.$2,
    padding: spacing.$1,
  },
  errorMessageContainerBase: {
    width: 240,
  },
  errorMessageContainerLg: {
    width: 260,
  },
});
